import React from 'react';
import styled from 'styled-components';
import { IConditionsData } from '../../container/Conditions/ConditionsData';

const Condition = ({ alt, text }: IConditionsData) => {
  return (
    <StyledCondition>
      <img src={`conditions/${alt}.svg`} alt={alt} />
      <ConditionText>{text}</ConditionText>
    </StyledCondition>
  );
};

const StyledCondition = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 27%;
  height: 144px;
  @media (max-width: 1440px) {
    width: 25%;
  }
  @media (max-width: 1135px) {
    width: 47%;
    height: 154px;
  }
`;

const ConditionText = styled.p`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-top: 16px;
  @media (max-width: 600px) {
    font-size: 20px;
    line-height: 28px;
    margin-top: 19px;
  }
  @media (max-width: 413px) {
    font-size: 16px;
    line-height: 21px;
  }
`;

export default Condition;
